import { Instance } from 'mobx-state-tree'
import { TeacherModelBase } from './TeacherModel.base'

/* The TypeScript type of an instance of TeacherModel */
export interface TeacherModelType extends Instance<typeof TeacherModel.Type> {}

/* A graphql query fragment builders for TeacherModel */
export { selectFromTeacher, teacherModelPrimitives, TeacherModelSelector } from './TeacherModel.base'

/**
 * TeacherModel
 */
export const TeacherModel = TeacherModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
